import { type ReactNode } from "react";
import { NavLink } from "react-router";
import { cn } from "@core/utils/domUtil";

function NavLinkItem({ to, children }: { to: string; children: ReactNode }) {
  return (
    <li>
      <NavLink to={to} className={({ isActive }) => cn("text-md relative flex h-[50px] items-center px-[20px] font-medium text-gray-500 lg:h-[60px] lg:text-lg", "before:bg-point-600 before:transition-width before:absolute before:bottom-0 before:left-[50%] before:h-[3px] before:w-0 before:duration-200 before:ease-in-out", "after:bg-point-600 after:transition-width after:absolute after:right-[50%] after:bottom-0 after:h-[3px] after:w-0 after:duration-200 after:ease-in-out", isActive && "text-point-600 before:w-[50%] after:w-[50%]")}>
        {children}
      </NavLink>
    </li>
  );
}

export default function NavLinkTabs() {
  return (
    <div className="sticky top-0 right-0 left-0 z-10 flex w-full items-center justify-center border-b border-gray-200 bg-white">
      <ul className="flex items-center gap-[20px]">
        <NavLinkItem to="/service/premium">멀티 프리미엄 서비스</NavLinkItem>
        <NavLinkItem to="/service/partner">파트너 PC방 프로그램</NavLinkItem>
      </ul>
    </div>
  );
}
